/* global Blockly */

import React from 'react';
import PropTypes from 'prop-types';
import MobiControlCore from '../../../v1/blocks/MobiControl/MobiControlCore';

const editImage = "data:image/svg+xml,%3Csvg id='Layer_1' data-name='Layer 1' fill='white' xmlns='http://www.w3.org/2000/svg' viewBox='0 3 25 25'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23141e25;%7D%3C/style%3E%3C/defs%3E%3Cpath d='M19.68,2,3.4,18.28,2,26l7.72-1.4L26,8.32Zm4,6.32-13.95,14-4-4,14-13.95ZM4.82,19.7,8.3,23.18,4.05,24Z'/%3E%3C/svg%3E";

function defineBlock(context, openJSEditor) {
    let prop = {...context};
    prop.tooltipText = "Execute MC JavaScript on the device (e.g. mobicontrol.lockdown.enable();). The Execute MobiControl JavaScript JS API is available within lockdown apps.";
    prop.responseText = "result";
    prop.responseBlockType = "text_response";
    let blockInstance = MobiControlCore(prop);

    blockInstance.code = '';

    // override default fields with an inline JS editor launcher (like snap_jsblocks_custom_js)
    blockInstance.addFields = function () {
        this.appendDummyInput()
            .appendField("execute MC JavaScript")
            .appendField(new Blockly.FieldImage(editImage, 20, 20, "edit", this.workspace.isCreateBlockWorkspace ? null : function () { this.openJSEditor(); }.bind(this)), "edit");
    };

    blockInstance.openJSEditor = function () {
        openJSEditor(this.id, this.setBlockCode.bind(this), this.code, 'mcJavaScript');
    };

    blockInstance.setBlockCode = function (code) {
        this.code = code;
    };

    blockInstance.mutationToDom = function () {
        let mutation = Blockly.utils.xml.createElement('mutation');
        mutation.setAttribute('blockcode', this.code);
        return mutation;
    };

    blockInstance.domToMutation = function (xml) {
        let code = xml.getAttribute('blockcode');
        this.setBlockCode(code);
    };

    return blockInstance;
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let coreResponseCode = block.getJavascriptCore();
            // JSON.stringify safely escapes the script when embedding it as a string literal
            return `Snap.mcLockdown.executeMCJavaScript(${JSON.stringify(block.code || '')}, ${coreResponseCode});\n`;
        }
    }
}

const MobiControlExecuteMCJavaScript = function (props) {
    const name = 'snap_mobicontrol_executemcjavascript';
    MobiControlExecuteMCJavaScript.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context, props.openJSEditor);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return <block type={name}></block>;
}

MobiControlExecuteMCJavaScript.propTypes = {
    context: PropTypes.object,
    openJSEditor: PropTypes.func
};

export default MobiControlExecuteMCJavaScript;
